<template>
  <v-app>
    <AppHeader ref="appHeader"/>

    <v-main class="main-body">
      <!-- body -->
      <v-container>
        <v-row>
          <v-col sm="12" md="12" cols="12">
            <v-card elevation="0" color="#F4F4F4">
              <v-card-title>{{curLanguage == 'en' ? curBanner.title: curBanner.title_zh}}</v-card-title>
              <v-card-text>{{curLanguage == 'en' ?curBanner.content: curBanner.content_zh}}</v-card-text>
              <v-row style="justify-content: center;">
                <v-col sm="10" md="10" cols="10">
                  <v-select
                    @change="selectCoin"
                    light
                    v-model="coinType"
                    :items="coinTypes"
                    item-text="name"
                    return-object
                    dense
                    color="#222222"
                    outlined
                    label="选择币种"
                    style="font-size:12px;border-color:#DEDCDC;"
                  ></v-select>
                </v-col>
                  <v-col sm="10" md="10" cols="10" class="no-padding-height">
                    <v-text-field
                        v-model="price"
                        :rules="priceRules"
                        type="number"
                        :label="$t('home.balance') + ':' + balance"
                        success
                        required
                      ></v-text-field>
                  </v-col>
                  <v-col sm="10" md="10" cols="10" class="no-padding-height">
                    <v-btn @click="reward" :loading="confirmStatus" color="#4737FF" elevation="1" tile class="head-btn" style="margin: 20px 0px;width:100%;">
                      <span style="color:white;">{{ $t('home.reward') }}</span>
                    </v-btn>
                  </v-col>

                </v-row>
              
            </v-card>
          </v-col>

          
        </v-row>


        
      </v-container>
    </v-main>
    <dialog-loader ref="dialogLoader"></dialog-loader>
    <confirm-dialog ref="confirmDialog" />
    <h-dialog />
    <!-- <h-notify />
    <h-loader /> -->

  </v-app>
</template>

<script>
import AppHeader from '../../components/AppHeader.vue';
import ConfirmDialog from '../../components/ConfirmDialog.vue';

export default {
  name: 'App',

  components: {
    AppHeader,
    ConfirmDialog
  },

  data: () => ({
    balance: '-',
    confirmStatus: false,
    price: null,
    priceRules: [
      v => !!v || 'Price is required'
    ],
    coinType: {},
    coinTypes: [{
      name: "CFX",
      address: "0x0000000000000000000000000000000000000000"
    },{
      name: "USDT",
      address: "0xfe97e85d13abd9c1c33384e796f10b73905637ce"
    },{
      name: "NUT",
      address: "0xfe197e7968807b311d476915db585831b43a7e3b"
    },{
      name: "ABC",
      address: "0x905f2202003453006eaf975699545f2e909079b8"
    },{
      name: "USDC",
      address: "0x6963efed0ab40f6c3d7bda44a05dcf1437c44372"
    },{
      name: "PPI",
      address: "0x22f41abf77905f50df398f21213290597e7414dd"
    }],
    isShow: -1,
    account: null,
    curLanguage: 'zh-cn',
    curActiveTab: 0,
    curBanner: {
      title: 'Reward ConfluxDapp',
      title_zh: '打赏 ConfluxDapp',
      content: 'Reward it, and you will be very rich in the future.',
      content_zh: '听说一位即将暴富的大佬，打赏了 ConfluxDapp。',
    },
    clockIcon: require('../../assets/svg/clock.svg'),
    trendingJson: [],
    hotbidJson: [],
    exploreJson: [],
    categoryList: [],
    boxList: [],
    currentCategory: 0,
    timelock: null,
    providers:[]
  }),
  mounted: async function() {
    //TODO:
    this.account = await this.$refs.appHeader.login('espace');

    window.addEventListener("eip6963:announceProvider", function(event) {
      console.log(event.detail.info.icon);
    })

  window.dispatchEvent(new Event("eip6963:requestProvider"));
   
  },
  watch: {
    account: {
      handler(newVal, oldVal) {
        
      },
      immediate: true
    },
    '$i18n.locale': {
      handler(newVal, oldVal) {

        if(newVal == 'zh-cn') {
          this.curLanguage = 'zh-cn'
        }
        if(newVal == 'en') {
          this.curLanguage = 'en'
        }
        
        
      },
      immediate: true
    }
  },
  beforeDestroy: function() {
    this.destoryClock()
  },
  methods: {
    login: async function() {
      this.account = await this.$refs.appHeader.login('espace');
    },
    reward: async function() {
      console.log("reward")
      if(this.balance < this.price) return;
      this.confirmStatus = true
      let that = this
      try {
        let result = await that.transferEthToken(this.coinType.address, this.globalVar.account, "0x4ae20E5152eD100Edb9dB1BDE1F7aD8ae354c7E5", this.price)
        console.log("result", result)
        if(result) {
          this.price = ''
          this.coinType = {}

          try {
          
            let title = that.$i18n.locale != 'en' ? "鸣谢": "Give thanks"
            let text_en = "Thank you, boss, for your gift."
            let text_cn = "感谢老板的馈赠，预感您将要暴富了！"
            let validBidText = that.$i18n.locale != 'en' ? text_cn : text_en
            let btns = that.$i18n.locale != 'en' ? ["取消","确认"]: ["Cancel","Confirm"]

            that.$refs.confirmDialog.confirm(title, validBidText , btns, async function() {
              
            })
            
          } catch(e) {
            console.log(e)
          }
        }
        
      } catch(e) {
        this.confirmStatus = false
      }
      
      this.confirmStatus = false
    },
    selectCoin: async function() {
      let that = this
      let balance = await that.getEthBalance(this.globalVar.account, this.coinType.address)

      this.balance = balance
    },
    destoryClock: function() {
      window.clearInterval(this.timelock)
      this.timelock = null
    },
    dealClock: function() {
      let that = this
      
      for(var i = 0 ; i < that.hotbidJson.length; i++) {
        if(null != that.hotbidJson[i].expirationTime) {
          
          let tempTime = that.hotbidJson[i].expirationTime
          that.hotbidJson[i].expirationTime = null
          that.hotbidJson[i].expirationTime = tempTime
        }
        
      }
      
    },
    loadCategory: function() {
      //Category
      window.API.category.getCategoryList.request({
        "count": 0,
        "pageSize": 10
      }).then(res => {
        this.categoryList = res.data.data.categoryList
      })
    },
    loadHotBid: function() {
      let that = this
      that.$refs.dialogLoader.show( that.$i18n.locale == 'en' ? 'Data Loading...' : '数据加载中...', { color: 'primary' } )

      that.destoryClock()
      //hot bid
      window.API.item.browseItemList.request({
        "category": "1",
        "count": 0,
        "pageSize": 4,
        "sortBy": "highestBid",
        "status": "auction"
      }).then(res => {
        if(0 == res.data.code) {
          this.hotbidJson = this.packageCollectibleData(res.data.data.itemList)

          that.timelock = setInterval(function() {
            that.dealClock()
          }, 1000)
        }

        that.$refs.dialogLoader.hide()
      })
    },
    listExplore(category) {
      let that = this
      //Expolre
      window.API.item.browseItemList.request({
        "category": '',
        "count": 0,
        "pageSize": 4,
        "sortBy": "recentList",
        "status": "buyNow"
      }).then(res => {
        
        if(0 == res.data.code) {
          
          that.exploreJson = this.packageCollectibleData(res.data.data.itemList)
        }
      })
    },
    loadCollection: function() {
      
      let that = this

      let params = {
        count: 0,
        pageSize: 4
      }

      window.API.collection.getTrendingCollectionList.request(params).then(res => {
        if(0 == res.data.code) {
          that.trendingJson = res.data.data.trendingCollection
        }
      })
      
    },

    loadBlindBox: function() {
      let that = this

      window.API.box.searchBox.request({
        "count": 0,
        "pageSize": 4,
        "search": '',
        "sortBy": ''
      }).then(res => {
        if(0 == res.data.code) {
          that.boxList = res.data.data.boxList
        }
        
      })
    },
    viewDetail4HotBid: function(n, type) {
      let id = this.hotbidJson[n]['id']
      this.$router.push({ name: 'Detail', params: {id: id, listingStatus: 1}, query: {id: id, listingStatus: 1}})
    },
    viewDetail: function(n, type) {
      let id = this.exploreJson[n]['id']
      this.$router.push({ name: 'Detail', params: {id: id, listingStatus: 1}, query: {id: id, listingStatus: 1}})
    },
    showMore: function() {
      // this.sheet = true;
      this.drawer = true;
    },
    showExplore: function(n) {

      if(typeof n == "number") {
        let collectionId = this.trendingJson[n].id
        this.$router.push({ name: 'Explore', params: {collectionId: collectionId}, query: {collectionId: collectionId}})
      } else {
        this.$router.push({ name: 'Explore', params: {}})
      }
      
    },
    showBlindBoxDetail: function(n, type){
      //添加样式
      this.isShow = n 

      let id = this.boxList[n]['id']
      this.$router.push({ name: 'BlindBoxDetail', params: {id: id, onlineOrNot: 1}, query:{id: id, onlineOrNot: 1}});
    }
  }

};
</script>

<style scoped>

  .tuoyuan {
    position: absolute;
    width: 8px;
    height: 8px;
    background: #7CD77B;
  }

  .main-body {
    background-color: #F4F4F4;
  }


  .head-img {
    margin: 0px 16px;
  }

  .card-box {
    padding-left: 16px;
  }

  .rectangle{
    width: 9vw;
    position: absolute;
    right: 0;
    top: 0;
    display: none;
  }

  .blind_box_img{
    position: absolute; 
  }

  .blind_box:before{
    content: '';
    padding-top: 100%;
    box-sizing: border-box;
    display: block;
    width: 0;
  }

  .open_now_btn{
    background: linear-gradient(90deg, #1434E1 2.87%, #4737FF 53.42%, rgba(20, 52, 225, 0.1) 100%);
    border-radius: 0px 16px 16px 16px;
    width: 40%;
    min-width: 78px!important;
    max-width: 400px!important;
    position: absolute;
    letter-spacing: -1px;
    color: #F8F8FA;
  }

  .blind_box{
    background: linear-gradient(0.39deg, #E4E4E4 0.25%, #FFFFFF 57.15%, #FFFFFF 99.57%);
    border-radius: 8px;
  }

  .active {
    border: 1px solid rgba(34, 34, 34);
  }

  .show {
    display: flex;
    width: 100%;
    margin:0;
  }

  .blind_box_price{
    font-family: Fira Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 10.6pt;
    text-align: right;
    letter-spacing: -1px;
    position: absolute;
    color: #1434E1;
    right: 9%;
    bottom: 16%;
  }

  
</style>
